export default __webpack_public_path__ + "static/media/next.40c0d8b5.svg";